import * as React from 'react';
import { Wrapper } from './StarRating.styled';
import { Star } from './Star';
import { theme } from '../../theme';
export const StarRating = ({ total, filled, shadow = 'NONE', range = 'TRUNCATED', size = 'regular', }) => {
    const stars = [];
    const filledStars = filled <= total ? Math.floor(filled) : total;
    for (let i = 1; i <= filledStars; i++) {
        stars.push(React.createElement(Star, { key: `star-${i}`, fillAmount: 1, lhsColor: theme.colors.YE100, rhsColor: "transparent", size: size, "aria-hidden": "true", truncateViewBox: false }));
    }
    const partialStar = filled <= total ? filled - Math.floor(filled) : 0;
    if (partialStar) {
        stars.push(React.createElement(Star, { key: `star-${stars.length + 1}`, fillAmount: partialStar, lhsColor: theme.colors.YE100, rhsColor: shadow === 'NONE' ? 'transparent' : theme.colors.LM_NU30, truncateViewBox: shadow === 'NONE', size: size, "aria-hidden": "true", "data-testid": "star-partial" }));
    }
    const starsToPad = range === 'FULL' ? total - Math.ceil(partialStar) - filledStars : 0;
    for (let i = 1; i <= starsToPad; i++) {
        stars.push(React.createElement(Star, { key: `star-${stars.length + 1}`, fillAmount: 0, lhsColor: shadow === 'ALL' ? theme.colors.LM_NU30 : 'transparent', rhsColor: shadow === 'ALL' ? theme.colors.LM_NU30 : 'transparent', truncateViewBox: range === 'TRUNCATED', size: size, "aria-hidden": "true" }));
    }
    const fixedStarRating = (filledStars + partialStar).toFixed(1);
    const ariaLabel = `Rating: ${fixedStarRating} out of ${total} stars`;
    return (React.createElement(Wrapper, { size: size, role: "img", "aria-label": ariaLabel }, stars));
};
//# sourceMappingURL=StarRating.js.map